export default function filterFunction(array = [], { search, tag, author }) {
    // console.log("file: filterFunction.js ~ line 2 ~ filterFunction ~ search", search)
    return array.filter(item => {
        if (search.length > 0) {
            if (!item.title.toLowerCase().includes(search.toLowerCase())) return false;
        }
        if (tag.length > 0) {
            if (!tag.includes(item.tag)) return false;
        }
        if (author.length > 0) {
            if (!author.includes(item.author)) return false;
        }

        return true;
    })

}